module.exports = __webpack_public_path__ + "img/rheumatology.9030bb8c.png";